import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CREATE_USER_REQUEST,
  GET_ALL_DEPARTMENT_LIST_REQUEST,
  GET_DEFAULT_ACCESS_REQUEST,
} from "../../Utils/Constant";
import CommonLoading from "../../Common/CommonLoading";
import { toast } from "react-toastify";
import { hasAddAccess } from "../../Common/CheckAccess";
import FormSelect from "../../Lib/FormSelect";

const CreateUser = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const { defaultAccess, loading: defaultLoading } = useSelector(
    (state) => state.settings
  );
  const { departmentList = {} } = useSelector((state) => state.department);
  const departments = departmentList?.data?.departments || [];
  const [permissionData, setPermissionData] = useState([]);

  const initialState =
  {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    role: "admin",
    permissions: [],
  }
    ;
  const [formData, setFormData] = useState(initialState);
  const [permissions, setPermissions] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  useEffect(() => {
    dispatch({ type: GET_ALL_DEPARTMENT_LIST_REQUEST });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !formData?.first_name ||
      !formData?.last_name ||
      !formData?.email ||
      !formData?.phone ||
      !formData?.password ||
      !formData?.role
    ) {
      toast.error("All fields are mendatory");
      return;
    }
    const hotel_id=localStorage.getItem('hotel_id');
    let dataFormat = {
      ...formData,
      hotel_id:hotel_id,
      permissions: permissionData,
      department_id: selectedDepartment !== 'all' ? selectedDepartment : null,
      global_access: selectedDepartment === 'all' ? true : false
    };

    dispatch({
      type: CREATE_USER_REQUEST,
      payload: dataFormat,
    });
    setFormData(initialState)

  };

  const allOptions = [
    { value: "super_admin", label: "Super Admin" },
    { value: "admin", label: "Admin" },
    { value: "front_desk", label: "Front Desk" },
    { value: "housekeeping", label: "Housekeeping" },
    { value: "restaurant_manager", label: "Restaurant Manager" },
    { value: "waiter", label: "Waiter" },
    { value: "inventory_manager", label: "Inventory Manager" },
    // { value: "accountant", label: "accountant" },
    { value: "manager", label: "Hotel Manager" },
  ];

  useEffect(() => {
    dispatch({
      type: GET_DEFAULT_ACCESS_REQUEST,
      payload: { id: "admin" },
    });
  }, []);

  const RoleChange = (e) => {
    dispatch({
      type: GET_DEFAULT_ACCESS_REQUEST,
      payload: { id: e.target.value },
    });

    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    setPermissionData(defaultAccess?.permissions);
  }, [defaultAccess]);

  const handleCheckboxChange = (index, field) => {
    const updatedPermissions = [...permissionData];
    updatedPermissions[index][field] = !updatedPermissions[index][field];
    setPermissionData(updatedPermissions);
  };

  return (
    <div
      className="container py-5 d-flex justify-content-center align-items-center"
      style={{ minHeight: "90vh" }}
    >
      <div
        className="shadow-lg p-5 bg-white rounded-4"
        style={{
          width: "100%",
          maxWidth: 1100,
          boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
        }}
      >
        <h2
          className="text-center mb-5 fw-bold"
          style={{ color: "#0d6efd", letterSpacing: "1.2px" }}
        >
          Create New User
        </h2>

        <form
          noValidate
          onSubmit={handleSubmit}
          autoComplete="off"
          style={{ fontSize: "1rem" }}
        >
          <div className="row g-3 mb-4">
            <div className="col d-flex align-items-center">
              <label
                htmlFor="first_name"
                className="form-label fw-semibold text-secondary mb-0"
                style={{ minWidth: "120px" }}
              >
                First Name
              </label>
              <input
                type="text"
                className={`form-control form-control-lg shadow-sm ${error ? "is-invalid" : ""}`}
                id="first_name"
                name="first_name"
                placeholder="First name"
                value={formData.first_name}
                onChange={handleChange}
                required
                style={{
                  borderRadius: "0.6rem",
                  borderColor: error ? "#dc3545" : "#ced4da",
                  marginLeft: "1rem",
                  transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                }}
                onFocus={(e) => (e.target.style.boxShadow = "0 0 5px #0d6efd")}
                onBlur={(e) => (e.target.style.boxShadow = "none")}
              />
            </div>
            <div className="col d-flex align-items-center">
              <label
                htmlFor="last_name"
                className="form-label fw-semibold text-secondary mb-0"
                style={{ minWidth: "120px" }}
              >
                Last Name
              </label>
              <input
                type="text"
                className={`form-control form-control-lg shadow-sm ${error ? "is-invalid" : ""}`}
                id="last_name"
                name="last_name"
                placeholder="Last name"
                value={formData.last_name}
                onChange={handleChange}
                required
                style={{
                  borderRadius: "0.6rem",
                  borderColor: error ? "#dc3545" : "#ced4da",
                  marginLeft: "1rem",
                  transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                }}
                onFocus={(e) => (e.target.style.boxShadow = "0 0 5px #0d6efd")}
                onBlur={(e) => (e.target.style.boxShadow = "none")}
              />
            </div>
          </div>

          <div className="mb-4 d-flex align-items-center">
            <label
              htmlFor="email"
              className="form-label fw-semibold text-secondary mb-0"
              style={{ minWidth: "120px" }}
            >
              Email
            </label>
            <input
              type="email"
              className={`form-control form-control-lg shadow-sm ${error ? "is-invalid" : ""}`}
              id="email"
              name="email"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              required
              autoComplete="email"
              style={{
                borderRadius: "0.6rem",
                borderColor: error ? "#dc3545" : "#ced4da",
                marginLeft: "1rem",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              onFocus={(e) => (e.target.style.boxShadow = "0 0 5px #0d6efd")}
              onBlur={(e) => (e.target.style.boxShadow = "none")}
            />
          </div>

          <div className="mb-4 d-flex align-items-center">
            <label
              htmlFor="phone"
              className="form-label fw-semibold text-secondary mb-0"
              style={{ minWidth: "120px" }}
            >
              Phone
            </label>
            <input
              type="tel"
              className={`form-control form-control-lg shadow-sm ${error ? "is-invalid" : ""}`}
              id="phone"
              name="phone"
              placeholder="Phone number"
              value={formData.phone}
              onChange={handleChange}
              // required
              autoComplete="tel"
              style={{
                borderRadius: "0.6rem",
                borderColor: error ? "#dc3545" : "#ced4da",
                marginLeft: "1rem",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              onFocus={(e) => (e.target.style.boxShadow = "0 0 5px #0d6efd")}
              onBlur={(e) => (e.target.style.boxShadow = "none")}
            />
          </div>

          <div className="mb-4 d-flex align-items-center">
            <label
              htmlFor="password"
              className="form-label fw-semibold text-secondary mb-0"
              style={{ minWidth: "120px" }}
            >
              Password
            </label>
            <input
              type="password"
              className={`form-control form-control-lg shadow-sm ${error ? "is-invalid" : ""}`}
              id="password"
              name="password"
              placeholder="Enter secure password"
              value={formData.password}
              onChange={handleChange}
              required
              autoComplete="new-password"
              style={{
                borderRadius: "0.6rem",
                borderColor: error ? "#dc3545" : "#ced4da",
                marginLeft: "1rem",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              onFocus={(e) => (e.target.style.boxShadow = "0 0 5px #0d6efd")}
              onBlur={(e) => (e.target.style.boxShadow = "none")}
            />
          </div>

          <div className="mb-4 d-flex align-items-center">
            <label
              htmlFor="role"
              className="form-label fw-semibold text-secondary mb-0"
              style={{ minWidth: "120px" }}
            >
              Role
            </label>
            <select
              className="form-select form-select-lg shadow-sm"
              id="role"
              name="role"
              value={formData.role}
              onChange={RoleChange}
              required
              style={{
                borderRadius: "0.6rem",
                borderColor: "#ced4da",
                marginLeft: "1rem",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              onFocus={(e) => (e.target.style.boxShadow = "0 0 5px #0d6efd")}
              onBlur={(e) => (e.target.style.boxShadow = "none")}
            >
              {allOptions?.map((itm) => {
                return (
                  <>
                    <option value={itm?.value}>{itm?.label}</option>
                  </>
                );
              })}
            </select>
          </div>

          {error && (
            <div
              className="alert alert-danger text-center rounded-3"
              role="alert"
            >
              {error}
            </div>
          )}
          {defaultLoading ? (
            <>
              <div className="col-12 d-flex justify-content-center py-5">
                <CommonLoading />
              </div>
            </>
          ) : (
            <div className="mt-4 px-0 w-100 mb-3">
              <div className="table-responsive rounded-4 border shadow-sm">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-secondary text-white">
                    <tr className="text-uppercase small text-center">
                      <th className="ps-4 text-start py-3">Resource</th>
                      <th className="py-3">View</th>
                      <th className="py-3">Add</th>
                      <th className="py-3">Update</th>
                      <th className="py-3">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissionData?.length > 0 ? (
                      permissionData?.map((item, index) => (
                        <tr key={index} className="border-bottom text-center">
                          <td className="ps-4 text-start fw-semibold text-capitalize py-3">
                            {item?.resource}
                          </td>
                          {[
                            "can_view",
                            "can_add",
                            "can_update",
                            "can_delete",
                          ].map((field) => (
                            <td key={field}>
                              <input
                                type="checkbox"
                                className="form-check-input m-0"
                                style={{ border: "1px solid #6c757d" }}
                                checked={item[field]}
                                onChange={() =>
                                  handleCheckboxChange(index, field)
                                }
                              />
                            </td>
                          ))
                          }
                          <td>
                            {item.resource === "departments" ? (
                              <FormSelect
                                name="department"
                                value={selectedDepartment}
                                onChange={(e) => setSelectedDepartment(e.target.value)}
                                options={[
                                  { value: "all", label: "All" },
                                  ...departments.map((dept) => ({
                                    value: dept.id,
                                    label: dept.name,
                                  })),
                                ]}
                                // selectClassName="form-select-sm"
                                placeholder="Select Department"
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-muted py-4">
                          No permissions found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <button
            type="submit"
            className="btn w-100 fw-bold text-white"
            disabled={loading || !hasAddAccess(permissions, "setting")}
            style={{
              fontSize: "1.2rem",
              padding: "0.85rem",
              borderRadius: "0.75rem",
              backgroundColor: loading ? "#6c757d" : "#0d6efd",
              boxShadow: !loading
                ? "0 8px 24px rgba(13, 110, 253, 0.4)"
                : "none",
              border: "none",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background-color 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              if (!loading) e.target.style.backgroundColor = "#0843c9";
            }}
            onMouseLeave={(e) => {
              if (!loading) e.target.style.backgroundColor = "#0d6efd";
            }}
          >
            {loading ? "Creating..." : "Create User"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateUser;
